import React from "react";
import { storageApi } from "../storage/storageApi";

export const RoleViewSelector = ({ children }) => {
  const { role: userRole } = storageApi.useGetUserRole();

  return children.find((c) => c?.props?.userRole === userRole);
};
